// Small utility method to sort items in order of ascending ID
function ascendingIdSort(a, b) {
  return a.id > b.id;
}

export function alphabeticalNameSort(a, b) {
  const nameA = a.name.toLowerCase();
  const nameB = b.name.toLowerCase();

  if (nameA < nameB)
    // sort string ascending
    return -1;
  if (nameA > nameB) return 1;
  return 0; // default return value (no sorting)
}

export default ascendingIdSort;
